import Marquee from "react-fast-marquee";
import { Wheat } from "lucide-react";

export const MarqueeBand = ({ items, dark = false }) => (
  <div
    className={`overflow-hidden border-y py-8 sm:py-10 ${
      dark ? "border-cream/10 bg-forest text-cream" : "border-border bg-sand/60 text-ink"
    }`}
    data-testid="editorial-marquee"
  >
    <Marquee speed={22} gradient={false}>
      {items.map((item, i) => (
        <span key={i} className="mx-10 flex items-center gap-20 sm:mx-14">
          <span className="whitespace-nowrap font-serif text-3xl font-light italic tracking-tight sm:text-4xl">
            {item}
          </span>
          <Wheat className={`h-6 w-6 shrink-0 ${dark ? "text-gold" : "text-terra"}`} strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </div>
);
